export enum PageTypeEnum {
    Hizmetler = "hizmetler",
    Programlar = "programlar",
    SSS = "sss",
    Blog = "blog",
}